import { Form, Input, Button, Typography, Carousel, Select, Modal } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { useCallback, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { login, setAccessToken, setCurrentSubscriptionId } from "services/auth";
import { ErrorMessages } from "constants/index";
import { AppLogoIcon } from "components/svg-icons";
import { LoginRequest } from "models/user";
import { NotFoundPage } from "pages";
import PiiConsent from "components/widgets/pii-consent";

const { Title } = Typography;

function ALogin() {
  const history = useHistory();
  const location = useLocation();
  const redirectUrl = new URLSearchParams(location.search).get("redirectUrl");

  const [loader, setLoader] = useState(false);
  const [loginForm] = Form.useForm();
  const [subscriptionForm] = Form.useForm();

  const [loginInfo, setloginInfo] = useState<any>(null);
  const [userSubscriptions, setUserSubscriptions] = useState<any[]>([]);

  const slider: any = useRef();

  const onLoginFinish = useCallback(
    async (event: LoginRequest) => {
      setLoader(true);
      const res: any = await login({
        email: event.email,
        password: event.password
      });

      if (res.status === 200) {
        setAccessToken(res.data.success.token);
        setloginInfo(res.data.success);
        setUserSubscriptions(res.data.success.associated_subscriptions);
        setCurrentSubscriptionId(
          res.data.success.associated_subscriptions[0].id
        );
        history.push(redirectUrl || "");
        setLoader(false);
      } else {
        console.log(res);
        Modal.error({ content: res.response?.data?.error || res.message });
      }
      setLoader(false);
    },
    [history, redirectUrl]
  );

  if (!redirectUrl) return <NotFoundPage />;
  return (
    <div className="login">
      <div className="login-form">
        <div className="mx-auto block">
          <AppLogoIcon />
        </div>
        <div className="login-logo">
          <Title level={3} className="mt-3">
            Login
          </Title>
        </div>
        <Carousel
          dots={false}
          afterChange={() => {}}
          ref={(ref) => {
            slider.current = ref;
          }}
          speed={250}
          infinite={false}
          swipe={false}
          swipeToSlide={false}
          draggable={false}
        >
          <div className="px-1">
            <Form
              onFinish={onLoginFinish}
              form={loginForm}
              labelCol={{ span: 50 }}
              wrapperCol={{ span: 30 }}
              scrollToFirstError
              layout="vertical"
              data-testid="a-login-form"
            >
              <FormItem
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    validateTrigger: "onSubmit",
                    message: ErrorMessages.EmailRequired
                  },
                  {
                    type: "email",
                    validateTrigger: "onSubmit",
                    message: ErrorMessages.EmailRequired
                  }
                ]}
              >
                <Input
                  placeholder="Enter Email"
                  tabIndex={loginInfo ? -1 : 0}
                  data-testid="a-login-input-email"
                />
              </FormItem>

              <FormItem
                name="password"
                label="Password"
                className="password"
                validateStatus=""
                rules={[
                  {
                    required: true,
                    validateTrigger: "onSubmit",
                    message: ErrorMessages.PasswordEmptyCheck
                  }
                ]}
              >
                <Input.Password
                  placeholder="Enter Password"
                  tabIndex={loginInfo ? -1 : 0}
                  data-testid="a-login-input-password"
                />
              </FormItem>

              <div className="pt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  className="w-full"
                  loading={loader}
                  disabled={loader}
                  tabIndex={loginInfo ? -1 : 0}
                  data-testid="a-login-button"
                >
                  Login
                </Button>
              </div>
            </Form>
          </div>

          <div className="px-1">
            <Form
              onFinish={(subscriptionData: any) => {
                setCurrentSubscriptionId(subscriptionData.subscriptionId);
                if (redirectUrl) history.push(redirectUrl);
                else history.push("/projects");
              }}
              form={subscriptionForm}
              labelCol={{ span: 50 }}
              wrapperCol={{ span: 30 }}
              scrollToFirstError
              layout="vertical"
              className="-mt-10"
              data-testid="a-login-form-2"
            >
              <FormItem name="subscriptionId" label="Choose a subscription">
                <Select
                  className="w-full"
                  onChange={() => {}}
                  options={userSubscriptions.map((sub: any) => {
                    return {
                      value: sub.id,
                      label: sub.name
                    };
                  })}
                  tabIndex={!loginInfo ? -1 : 0}
                />
              </FormItem>

              <div className="w-full grid grid-cols-3 content-center pt-4">
                <div className="flex justify-center">
                  <Button
                    htmlType="submit"
                    size="middle"
                    loading={loader}
                    disabled={loader}
                    tabIndex={!loginInfo ? -1 : 0}
                    data-testid="a-login-button-2"
                  >
                    Continue
                  </Button>
                </div>
                <div />
              </div>
            </Form>
          </div>
        </Carousel>
      </div>
      <PiiConsent className="w-[350px] text-center text-xs text-ciq-gray-470" />
    </div>
  );
}

export default ALogin;
